import React from 'react';

import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

import { EmbroideryLine, DetailText } from './styles';

const locationRbs = defineMessages({
  1: {
    id: 'site_pdp.embroidery_left_shoulder',
    defaultMessage: 'Left Shoulder',
  },
  2: {
    id: 'site_pdp.embroidery_right_shoulder',
    defaultMessage: 'Right Shoulder',
  },
});

const LogoCustomizations = ({ logoCustomizations }) => {
  if (!logoCustomizations.logo) {
    return null;
  }

  const { logoLocation, logo } = logoCustomizations;

  const translatedLocation = locationRbs[logoLocation];

  return (
    <>
      <EmbroideryLine>
        <FormattedMessage
          id="site_pdp.embroidery_sleeve_tag_line_item"
          defaultMessage="Sleeve Tag"
        />
        {': '}
        <DetailText>{`${logo},`}</DetailText>{' '}
        {translatedLocation?.id && (
          <DetailText>
            <FormattedMessage {...translatedLocation} />
          </DetailText>
        )}
      </EmbroideryLine>
    </>
  );
};

LogoCustomizations.propTypes = {
  logoCustomizations: PropTypes.shape({
    logoLocation: PropTypes.oneOf([1, 2]),
    logo: PropTypes.string,
  }),
};

export default LogoCustomizations;
